"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameAction = exports.GameServerResponse = exports.GameServerEvent = void 0;
var GameServerEvent;
(function (GameServerEvent) {
    GameServerEvent["Default"] = "";
    GameServerEvent["Register"] = "Auth:Emit:Register";
    GameServerEvent["Login"] = "Auth:Emit:Login";
    GameServerEvent["Logout"] = "Auth:Emit:Logout";
    GameServerEvent["ChangePassword"] = "Auth:Emit:ChangePassword";
    GameServerEvent["ChangeEmail"] = "Auth:Emit:ChangeEmail";
    GameServerEvent["ForgotPassword"] = "Auth:Emit:ForgotPassword";
    GameServerEvent["RequestVerification"] = "Auth:Emit:RequestVerification";
    GameServerEvent["SubmitVerification"] = "Auth:Emit:SubmitVerification";
    GameServerEvent["ChangeDiscordTag"] = "Auth:Emit:ChangeDiscordTag";
    GameServerEvent["ChangeAlwaysOnline"] = "Auth:Emit:ChangeAlwaysOnline";
    GameServerEvent["ChangeEventWatcher"] = "Auth:Emit:ChangeEventWatcher";
    GameServerEvent["SetMOTD"] = "GM:Emit:SetMOTD";
    GameServerEvent["BlockAndKickAll"] = "GM:Emit:BlockAndKickAll";
    GameServerEvent["Announce"] = "GM:Emit:Announce";
    GameServerEvent["ForceReboot"] = "GM:Emit:ForceReboot";
    GameServerEvent["ForceRebootLocal"] = "GM:Emit:ForceRebootLocal";
    GameServerEvent["CharacterCreateInformation"] = "Creator:Emit:CharacterSelect";
    GameServerEvent["DeleteCharacter"] = "Selector:Emit:CharacterDelete";
    GameServerEvent["CreateCharacter"] = "Selector:Emit:CharacterCreate";
    GameServerEvent["PlayCharacter"] = "Selector:Emit:CharacterPlay";
    GameServerEvent["Chat"] = "Chat:Emit:SendMessage";
    GameServerEvent["QuitGame"] = "Game:Emit:QuitGame";
    GameServerEvent["DoCommand"] = "Game:Emit:DoCommand";
    GameServerEvent["PremiumBuy"] = "Premium:Buy:Item";
    GameServerEvent["PremiumSilverBuy"] = "Premium:SilverBuy:Item";
    GameServerEvent["CodeRedeem"] = "Code:Redeem:Single";
    GameServerEvent["BugReport"] = "BugReport:Emit:InGame";
})(GameServerEvent || (exports.GameServerEvent = GameServerEvent = {}));
var GameServerResponse;
(function (GameServerResponse) {
    GameServerResponse["Error"] = "error";
    GameServerResponse["Login"] = "Auth:Response:Login";
    GameServerResponse["UserJoin"] = "Lobby:Response:UserJoin";
    GameServerResponse["UserLeave"] = "Lobby:Response:UserLeave";
    GameServerResponse["UserCountUpdate"] = "Lobby:Response:UserCountUpdate";
    GameServerResponse["Chat"] = "Chat:Response:Message";
    GameServerResponse["CharacterCreateInformation"] = "Creator:Response:CharacterSelect";
    GameServerResponse["CharacterCreate"] = "Creator:Response:CharacterCreate";
    GameServerResponse["SetEvents"] = "Event:Response:Set";
    GameServerResponse["CreateEvent"] = "Event:Response:Create";
    GameServerResponse["DeleteEvent"] = "Event:Response:Delete";
    GameServerResponse["GameLog"] = "Game:Response:Message";
    GameServerResponse["SendNotification"] = "Game:Response:Notification";
    GameServerResponse["SendImportantNotification"] = "Game:Response:ImportantNotification";
    GameServerResponse["SendAlert"] = "Game:Response:Alert";
    GameServerResponse["SendConfirm"] = "Game:Response:Confirm";
    GameServerResponse["SendInput"] = "Game:Response:SendInput";
    GameServerResponse["SendAchievement"] = "Game:Response:SendAchievement";
    GameServerResponse["DialogChat"] = "Game:Response:NPCDialog";
    GameServerResponse["PlaySFX"] = "Game:Response:PlaySFX";
    GameServerResponse["PlayCFX"] = "Game:Response:PlayCFX";
})(GameServerResponse || (exports.GameServerResponse = GameServerResponse = {}));
var GameAction;
(function (GameAction) {
    GameAction["Login"] = "[Account] Log In";
    GameAction["Logout"] = "[Account] Log Out";
    GameAction["SetCharacterSlotInformation"] = "[Account] Set Charslot Info";
    GameAction["SetAccount"] = "[Account] Set Account";
    GameAction["ChatAddMessage"] = "[Chat] Add Message";
    GameAction["ChatSetMOTD"] = "[Chat] Set MOTD";
    GameAction["ChatSetUserList"] = "[Chat] Set User List";
    GameAction["ChatAddUser"] = "[Chat] Add User";
    GameAction["ChatRemoveUser"] = "[Chat] Remove User";
    GameAction["ChatUserEnterGame"] = "[Chat] User Enter Game";
    GameAction["ChatUserLeaveGame"] = "[Chat] User Leave Game";
    GameAction["SettingsSetAssetHash"] = "[Settings] Set Server Asset Hash";
    GameAction["SettingsSetChatMode"] = "[Settings] Set Chat Mode";
    GameAction["SettingsSetLogMode"] = "[Settings] Set Log Mode";
    GameAction["SettingsSetCharacterView"] = "[Settings] Set Character View";
    GameAction["SettingsSetServerTimestamp"] = "[Settings] Set Server Timestamp";
    GameAction["SetCharacterCreateInformation"] = "[CharSelect] Set Create Info";
    GameAction["EventSetList"] = "[Events] Set List";
    GameAction["EventCreate"] = "[Events] Create Event";
    GameAction["EventDelete"] = "[Events] Delete Event";
    GameAction["GamePlay"] = "[Game] Play Game";
    GameAction["GamePlayerReady"] = "[Game] Player Ready";
    GameAction["GameQuit"] = "[Game] Quit Game";
    GameAction["GameSetMap"] = "[Game] Set Map";
    GameAction["GameSetPlayer"] = "[Game] Set Player";
    GameAction["GameSetPosition"] = "[Game] Set Position";
    GameAction["GamePatchPlayer"] = "[Game] Patch Player";
    GameAction["GamePatchPlayerState"] = "[Game] Patch Player State";
    GameAction["LogCurrentCommand"] = "[Game] Log Current Command";
    GameAction["SetCurrentCommand"] = "[Game] Set Current Command";
    GameAction["SetOption"] = "[Game] Set Option";
    GameAction["SetCurrentTarget"] = "[Game] Set Current Target";
    GameAction["SetCurrentItemTooltip"] = "[Game] Set Current Item Tooltip";
    GameAction["ViewCharacterEquipment"] = "[Game] View Character Equipment";
    GameAction["CreateCustomMacro"] = "[Macro] Create Custom";
    GameAction["DeleteCustomMacro"] = "[Macro] Delete Custom";
    GameAction["SetActiveMacro"] = "[Macro] Set Active Macro";
    GameAction["LearnMacro"] = "[Macro] Learn Macro";
    GameAction["SetActiveMacroBars"] = "[Macro] Set Active Bars";
    GameAction["SetMacroBar"] = "[Macro] Set Macro Bars";
    GameAction["SetDefaultMacros"] = "[Macros] Set Default Macros/Bars";
    GameAction["ImportMacros"] = "[Macros] Import Macros";
    GameAction["UpdateJournal"] = "[Journal] Update Journal";
    GameAction["SettingsAddAccount"] = "[Settings] Add Quick Account";
    GameAction["SettingsRemoveAccount"] = "[Settings] Remove Quick Account";
    GameAction["SettingsUpdateWindowPosition"] = "[Settings] Update Window Position";
    GameAction["SettingsSetDefaultWindowPosition"] = "[Settings] Set Default Window Position";
    GameAction["SettingsResetWindowPositions"] = "[Settings] Reset Window Positions";
    GameAction["SettingsHideWindow"] = "[Settings] Hide Window";
    GameAction["SettingsShowWindow"] = "[Settings] Show Window";
    GameAction["SettingsToggleWindow"] = "[Settings] Toggle Window";
    GameAction["SettingsActiveWindow"] = "[Settings] Set Active Window";
    GameAction["SettingsCharSlot"] = "[Settings] Set Char Slot";
    GameAction["SettingsLastPlayedCharSlot"] = "[Settings] Last Played Char Slot";
    GameAction["SettingsSetAllWindowPositions"] = "[Settings] Set All Window Positions";
    GameAction["NPCActionShowTrainer"] = "[NPC] Show Trainer";
    GameAction["NPCActionHideTrainer"] = "[NPC] Hide Trainer";
    GameAction["NPCActionShowVendor"] = "[NPC] Show Vendor";
    GameAction["NPCActionHideVendor"] = "[NPC] Hide Vendor";
    GameAction["NPCActionShowBank"] = "[NPC] Show Bank";
    GameAction["NPCActionHideBank"] = "[NPC] Hide Bank";
    GameAction["NPCActionShowMarket"] = "[NPC] Show Market";
    GameAction["NPCActionHideMarket"] = "[NPC] Hide Market";
    GameAction["ShowTradeskill"] = "[Window] Show Tradeskill";
    GameAction["HideTradeskill"] = "[Window] Hide Tradeskill";
    GameAction["LockerActionShow"] = "[Locker] Show Locker";
    GameAction["LockerActionHide"] = "[Locker] Hide Locker";
    GameAction["PartyUpdate"] = "[Party] Update Party";
    GameAction["SetSessionStatistics"] = "[Session] Set Statistics";
    GameAction["UpdateGuild"] = "[Guild] Update Guild";
    GameAction["UpdateGuildAuditLog"] = "[Guild] Update Audit Log";
})(GameAction || (exports.GameAction = GameAction = {}));
